import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";


export default class CustomerSales extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		props.parent ? this.request = "GET_CUSTOMER" : null;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [
			{
				Header: "Sold Date",
				id: "sold_date",
				/** @param {Av_Keys_Object} obj */
				accessor: obj => {
					return obj.sold_date ? moment(obj.sold_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "User Who Sold It",
				id: "user",
				/** @param {Av_Keys_Object} obj */
				accessor: obj => (obj.users ? (obj.users.name_first + " " + obj.users.name_last) : "Admin")
			},
			{
				Header: "Product Name",
				id: "product_name",
				accessor: "product_name"
			},
			{
				Header: "Key",
				id: "activation_key",
				accessor: "activation_key"
			},
		];


		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('AV Keys')}
							{this.renderHeaderRight("AV Keys", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
